var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdvancedSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.43 23.93c0-3.45.01-6.9 0-10.36 0-1.07.49-1.79 1.39-2.31 2.14-1.23 4.26-2.49 6.39-3.72 2.22-1.29 4.45-2.57 6.67-3.85 1.51-.87 3.04-1.72 4.52-2.64 1.01-.63 1.95-.57 2.94.01 3.31 1.93 6.62 3.84 9.92 5.77 2.63 1.53 5.25 3.06 7.87 4.59.86.5 1.21 1.31 1.21 2.23q.03 10.305 0 20.61c0 1.18-.68 1.94-1.66 2.51-4.09 2.35-8.17 4.72-12.25 7.08-1.71.99-3.43 1.99-5.12 3.01-1.16.7-2.19.45-3.29-.21-2.64-1.59-5.33-3.12-8-4.67-2.19-1.27-4.38-2.55-6.57-3.83-.91-.53-1.83-1.05-2.75-1.58-.8-.47-1.26-1.17-1.27-2.13z",
    fill: "#f8e4da"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3 21.9c0 2.295-.745 4.415-2 6.135l6.33 6.335a1.602 1.602 0 0 1-2.265 2.265l-6.33-6.335c-1.72 1.26-3.84 2-6.135 2-5.745 0-10.4-4.655-10.4-10.4s4.655-10.4 10.4-10.4 10.4 4.655 10.4 10.4m-10.4 7.2a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 1 0 0 14.4",
    fill: "#f5874c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvancedSearch);
export default __webpack_public_path__ + "static/media/advanced-search.e0e251bf7ddc8a5e8dd7264866ce33f9.svg";
export { ForwardRef as ReactComponent };